<template>
  <div :style="[styles.base,styles.fontStyle]"
       :class="getCss('progress-max')">
    <!-- 横板 -->
    <div :class="getCss('across')" v-if="acrossVertival === 1" ref="upAndDown">
      <!-- 上文字0/300 -->
      <div v-if="textPosition === 1" :class="getCss('progress-proportion')"
           :style="{width:endsValueStyle}">
        <div ref="nameA" :class="getCss('endlongS')" :style="{color:fontColorPro}" v-for="(item,index) in addContent"
            :key="index">{{ forntText }}
          <span>{{ targetValue }}</span>/<span>{{ item.text }}</span>{{ queenText }}
        </div>
      </div>
      <!-- 进度条 -->
      <div :class="getCss('across-bd')">
        <div :class="getCss('frame-quantity')" :style="crossComputeStyle">
          <div v-if="picProgressType === 1"
               :style="{width:widthQuartity,backgroundColor:progressBarBgColor,borderRadius:progressBoradius}"
               :class="getCss('frame-quantity-center')">
            <img
              v-if="styles.image.src"
              width="100%"
              height="100%"
              v-src="styles.image.src"
              :alt="styles.image.alt"
            >
          </div>
          <div v-if="picProgressType === 2" :class="getCss('frame-quantity-picclip')">
            <img
              v-if="styles.image.src"
              width="100%"
              height="100%"
              v-src="styles.image.src"
              :alt="styles.image.alt"
              :style="{clipPath:picClipPath}"
              >
          </div>
          <div v-if="picProgressType === 3" :class="getCss('frame-quantity-contain')">
            <img
              v-if="styles.image.src"
              width="100%"
              v-src="styles.image.src"
              :alt="styles.image.alt"
              :style="{clipPath:picClipPath}"
              >
          </div>
          <!-- 中间进度文字 -->
          <div v-if="textPosition === 2 && addContent.length === 1" :class="getCss('progress-proportion2')">
            <div :class="getCss('progress-single')" :style="{color:fontColorPro, lineHeight:progressBarHeight2}"
              v-for="(item,index) in addContent" :key="index">
              {{ forntText }}<span>{{ targetValue }}</span>/<span>{{ item.text }}</span>{{ queenText }}
            </div>
          </div>
          <div v-if="textPosition === 2 && addContent.length !== 1" :class="getCss('progress-proportion2')">
            <div ref="nameA" :class="getCss('endlongS')" :style="{color:fontColorPro, lineHeight:progressBarHeight2}"
              v-for="(item,index) in addContent" :key="index">{{ forntText }}
              <span>{{ targetValue }}</span>/<span>{{ item.text }}</span>{{ queenText }}
            </div>
          </div>
        </div>
        <div v-show="endsValue" :class="getCss('across-end')" :style="{height:progressBarHeight}">
            <div :class="getCss('across-min')" :style="{color:fontColor}">0</div>
            <div :class="getCss('across-max')" :style="{color:fontColor}">{{ theNumberOfTerms || '' }}</div>
        </div>
      </div>
      <!-- 下文字0/300 -->
      <div v-if="textPosition === 3" :class="getCss('progress-proportion')"
           :style="{width:endsValueStyle}">
        <div ref="nameA" :class="getCss('endlongS')" :style="{color:fontColorPro}" v-for="(item,index) in addContent"
            :key="index">{{ forntText }}
          <span>{{ targetValue }}</span>
          /<span>{{ item.text }}</span>{{ queenText }}
        </div>
      </div>
    </div>
    <!-- 竖版 -->
    <div :class="getCss('vertival')" v-else ref="leftAndRight">
      <div :class="getCss('vertival-center')">
        <!-- 左进度文字 -->
        <div v-if="textPosition === 1" :class="getCss('vertival-price')"
             :style="{height:endsValueStyle}">
          <div ref="nameV" :class="getCss('acrossS')" v-for="(item,index) in addContent" :key="index">
            <div style="text-align: right" :style="{color:fontColorPro}" ref="positionR">
              {{ forntText }}<span>{{ targetValue }}</span>/<span>{{ item.text }}</span>{{ queenText }}
            </div>
          </div>
        </div>
        <!-- 进度条 -->
        <div :class="getCss('vertival-bd')" :style="{width:progressBarHeight}">
          <div v-show="endsValue" :class="getCss('vertival-max')" :style="{color:fontColor}">
            {{ theNumberOfTerms || '' }}
          </div>
          <div :class="getCss('frame-quantity-hieght')" :style="verticalComputeStyle">
            <div v-if="picProgressType === 1"
                 :style="{height:widthQuartity,backgroundColor:progressBarBgColor,borderRadius:progressBoradius}"
                 :class="getCss('frame-quantity-centerH')">
              <img
                v-if="styles.image.src"
                width="100%"
                height="100%"
                v-src="styles.image.src"
                :alt="styles.image.alt"
              >
            </div>
            <div v-if="picProgressType === 2" :class="getCss('vertival-pic-gary')">
                <img
                  v-if="styles.image.src"
                  width="100%"
                  height="100%"
                  v-src="styles.image.src"
                  :alt="styles.image.alt"
                  :style="{clipPath:picVertivalClipPath}"
                >
            </div>
            <div v-if="picProgressType === 3" :class="getCss('vertival-pic-contain')">
                <img
                  v-if="styles.image.src"
                  height="100%"
                  v-src="styles.image.src"
                  :alt="styles.image.alt"
                  :style="{clipPath:picVertivalClipPath}"
                >
            </div>
            <!-- 中间进度文字 -->
            <div v-if="textPosition === 2 && addContent.length === 1" :class="getCss('vertival-price2')">
              <div :class="getCss('progress-single-v')" v-for="(item,index) in addContent" :key="index">
                <div :class="getCss('text-c')" :style="{color:fontColorPro}">
                  {{ forntText }}<span>{{ targetValue }}</span>/<span>{{ item.text }}</span>{{ queenText }}
                </div>
              </div>
            </div>
            <div v-if="textPosition === 2 && addContent.length !== 1" :class="getCss('vertival-price2')">
              <div ref="nameV" :class="getCss('acrossS')" v-for="(item,index) in addContent" :key="index">
                <div :class="getCss('text-c')" :style="{color:fontColorPro}" ref="positionR">
                  {{ forntText }}<span>{{ targetValue }}</span>/<span>{{ item.text }}</span>{{ queenText }}
                </div>
              </div>
            </div>
          </div>
          <div v-show="endsValue" :class="getCss('vertival-min')" :style="{color:fontColor}">0</div>
        </div>
        <!-- 右进度文字 -->
       <div :class="getCss('vertival-price')" :style="{height:endsValueStyle}"
         v-if="textPosition === 3">
          <div ref="nameV" :class="getCss('acrossS')" v-for="(item,index) in addContent" :key="index">
            <div :style="{color:fontColorPro}" ref="positionR">
              {{ forntText }}<span>{{ targetValue }}</span> /
              <span>{{ item.text }}</span>{{ queenText }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { componentBaseMixin, common } from '@tencent/ceiba-base-components';

export default {
  name: 'CProgressBar',
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'progress-bar-',
      targetValue: 0, // 领取人数
      widthQuartity: '0%', // 进度条占比
      picClipPath: 'polygon(0 0, 0 0, 0 100%, 0 100%)', // (0 0, 0 0, 0 100%, 0 100%)   0 0, 50% 0, 50% 100%, 0 100%
      picVertivalClipPath: 'polygon(0 100%, 100% 100%, 100% 100%, 0 100%)', // (0 100%, 100% 100%, 100% 100%, 0 100%)
    };
  },
  computed: {
    acrossVertival() { // 横板和竖版切换
      return this.configurationData.acrossVertival;
    },
    textPosition() { // 文字位置
      return this.configurationData.textPosition;
    },
    progressBarBdColor() { // 进度条边框颜色
      return this.configurationData.progressBarBdColor;
    },
    progressBarBgColor() { // 进度条颜色
      return this.configurationData.progressBarBgColor;
    },
    progressBoradius() { // 圆边
      if (this.deviceMode === 'pc') {
        return this.configurationData.progressBoradius;
      }
      const style = common.tool.transformStyle({ progressBoradius: this.configurationData.progressBoradius });
      return style.progressBoradius;
    },
    fontColor() { // 字体颜色
      return this.configurationData.fontColor;
    },
    fontColorPro() { // 进度值字体颜色
      return this.configurationData.fontColorPro;
    },
    addContent() { // 自定义量
      return this.configurationData.addContent;
    },
    progressBarHeight() { // 进度条宽度
      if (this.deviceMode === 'pc') {
        return this.configurationData.progressBarHeight;
      }
      const style = common.tool.transformStyle({ progressBarHeight: this.configurationData.progressBarHeight });
      return style.progressBarHeight;
    },
    progressBarHeight2() { // 进度条宽度2
      const oldHeight = parseInt(this.configurationData.progressBarHeight, 10);
      if (oldHeight > 4 && this.configurationData.textPosition === 2) {
        const newHeight = `${String(oldHeight - 4)}px`;
        if (this.deviceMode === 'pc') {
          return newHeight;
        }
        const style = common.tool.transformStyle({ progressBarHeight: newHeight });
        return style.progressBarHeight;
      }
      if (this.deviceMode === 'pc') {
        return this.configurationData.progressBarHeight;
      }
      const style = common.tool.transformStyle({ progressBarHeight: this.configurationData.progressBarHeight });
      return style.progressBarHeight;
    },
    theNumberOfTerms() { // 最大值
      return this.configurationData.theNumberOfTerms;
    },
    forntText() { // 文字左侧
      return this.configurationData.forntText;
    },
    queenText() { // 文字右侧
      return this.configurationData.queenText;
    },
    progressBgColor() { // 背景色
      return this.configurationData.progressBgColor;
    },
    maxBackground() { // 进度条背景图
      return `url(${this.configurationData.maxBackground})`;
    },
    borderHeights() { // 进度条边框厚度
      return this.configurationData.borderHeights;
    },
    // 表达式 {{total_score}}
    targetText() {
      return this.configurationData.targetText;
    },
    picProgressType() { // 进度图片类型切换
      return this.configurationData.picProgressType;
    },
    endsValue() { // 两端数值显示
      return this.configurationData.endsValue;
    },
    endsValueStyle() { // 两端数值显示-样式
      return this.configurationData.endsValue ? '80%' : '100%';
    },
    backgroundSizeCrossStyle() { // 背景尺寸横版样式
      return this.configurationData.picProgressType === 3 ? '100% auto' : '100% 100%';
    },
    backgroundSizeVerticalStyle() { // 背景尺寸竖版样式
      return this.configurationData.picProgressType === 3 ? 'auto 100%' : '100% 100%';
    },
    backgroundPositionStyle() { // 背景位置样式
      return this.configurationData.picProgressType === 3 ? '0% 0%' : 'center';
    },
    crossComputeStyle() { // 横版进度样式
      const { endsValue, picProgressType } = this.configurationData;
      const heightStyle = common.tool.transformStyle({ progressBarHeight: this.configurationData.progressBarHeight });
      const boradiusStyle = common.tool.transformStyle({ progressBoradius: this.configurationData.progressBoradius });
      return {
        height: this.deviceMode === 'pc' ? this.configurationData.progressBarHeight : heightStyle.progressBarHeight,
        borderColor: this.configurationData.progressBarBdColor,
        borderRadius: this.deviceMode === 'pc' ? this.configurationData.progressBoradius : boradiusStyle.progressBoradius,
        backgroundColor: this.configurationData.progressBgColor,
        backgroundImage: `url(${this.configurationData.maxBackground})`,
        borderWidth: this.configurationData.borderHeights,
        width: endsValue ? '80%' : '100%',
        backgroundSize: picProgressType === 3 ? '100% auto' : '100% 100%',
        backgroundPosition: picProgressType === 3 ? '0% 0%' : 'center',
      };
    },
    verticalComputeStyle() { // 竖版进度样式
      const { endsValue, picProgressType } = this.configurationData;
      const heightStyle = common.tool.transformStyle({ progressBarHeight: this.configurationData.progressBarHeight });
      const boradiusStyle = common.tool.transformStyle({ progressBoradius: this.configurationData.progressBoradius });
      return {
        borderColor: this.configurationData.progressBarBdColor,
        width: this.deviceMode === 'pc' ? this.configurationData.progressBarHeight : heightStyle.progressBarHeight,
        borderRadius: this.deviceMode === 'pc' ? this.configurationData.progressBoradius : boradiusStyle.progressBoradius,
        backgroundColor: this.configurationData.progressBgColor,
        backgroundImage: `url(${this.configurationData.maxBackground})`,
        borderWidth: this.configurationData.borderHeights,
        height: endsValue ? '80%' : '100%',
        backgroundSize: picProgressType === 3 ? 'auto 100%' : '100% 100%',
        backgroundPosition: picProgressType === 3 ? '0% 0%' : 'center',
      };
    },
  },
  async mounted() {
    console.log('configurationData=', this.configurationData);
    await this.initialize();
  },
  methods: {
    async initialize() {
      if (this.$isInEditor) {
        this.picClipPath = 'polygon(0 0, 50% 0, 50% 100%, 0 100%)';
        this.picVertivalClipPath = 'polygon(0 50%, 100% 50%, 100% 100%, 0 100%)';
        return true;
      }
      const { initDataType = 1 } = this.configurationData;
      this.handleProcess();
      if (initDataType === 1) {
        this.$onRoleReady(() => {
        });
      } else if (initDataType === 2) {
        this.$onQuaRefreshed(() => {
          this.handleProcess();
        });
      }
    },
    getFields(object, querys) {
      if (querys.length > 1) {
        const key = querys.shift();
        return this.getFields(object[key], querys);
      }
      let field = 0;
      if (querys[0] in object) {
        field = object[querys[0]];
      }
      return field;
    },
    async handleProcess() {
      const addAcross = this.$refs.nameA;// 横板
      const addVertival = this.$refs.nameV;// 竖版
      const res = await this.flowRequest({
        flowId: this.configurationData.percentageFlowId,
        params: {
          role: this.roleInfo,
        },
      });
      console.log('测试流程：', res);
      const { data = {} } = res;
      // 使用replaceAll 导致无法解析 (_r, match) => {}  暂使用replace
      let targetValue = this.targetText.replace(
        /{{\s?([A-Za-z0-9_\\.]+)\s?}}/g,
        (_r, match) => this.getFields(data, match.split('.')),
      );
      targetValue = parseInt(targetValue, 10);
      if (isNaN(targetValue)) {
        targetValue = 0;
      }
      console.log(targetValue);
      if (targetValue > -1) { // 领取人数
        console.log(targetValue);
        this.targetValue = targetValue;
        const addCons = this.addContent;
        const { isDynamicWidth } = this.configurationData;
        if (isDynamicWidth) {
          addCons.forEach((item, index) => { // 动态调整文字位置
            console.log('addAcross------------', addAcross);
            if (addAcross && addAcross.length > 0) {
              if (index !== 0) {
                const difference = item.text - this.addContent[index - 1].text;
                const widthHeight = `${difference / this.theNumberOfTerms * 100}%`;
                addAcross[index].style.width = widthHeight;
              } else {
                const fisterWidthHeight = `${item.text / this.theNumberOfTerms * 100}%`;
                addAcross[index].style.width = fisterWidthHeight;
              }
            }
            if (addVertival && addVertival.length > 0) {
              if (index !== 0) {
                const difference = item.text - this.addContent[index - 1].text;
                const widthHeight = `${difference / this.theNumberOfTerms * 100}%`;
                addVertival[index].style.height = widthHeight;
              } else {
                const fisterWidthHeight = `${item.text / this.theNumberOfTerms * 100}%`;
                addVertival[index].style.height = fisterWidthHeight;
              }
            }
          });
        }

        const percentage = this.targetValue / this.theNumberOfTerms;
        const picWidthQuartity = `${percentage * 100}%`;
        const picVertivalQuartity = `${(1 - percentage) * 100}%`;
        this.widthQuartity = `${percentage * 100}%`;
        this.picClipPath = `polygon(0 0, ${picWidthQuartity} 0, ${picWidthQuartity} 100%, 0 100%)`;
        this.picVertivalClipPath = `polygon(0 ${picVertivalQuartity}, 100% ${picVertivalQuartity}, 100% 100%, 0 100%)`;
      }
    },
  },
};
</script>
<style lang="scss">
@import './styles.scss';
</style>
